import { html } from "lit-html";
import { each, If } from "../../../../core/component";
import { CategorySuggest, HistorySuggest } from "../../models/history_suggest";
import { KeywordDetailJsEnv } from "../../models/keyword_detail_js_env";
import { SearchwordSuggestionContainer } from "./searchword_suggestion_container";

export const SearchwordSuggestion = (model: KeywordDetailJsEnv) => {
  if (model.historySuggest) {
    return HistorySuggestion(model.historySuggest);
  } else if (model.suggest && model.suggest.shouldShow) {
    return html`
      <div class="o-header_search_candidate_item">
        <div class="a-heading -typep">
          <p class="a-heading_text">${model.suggest.title}</p>
        </div>
        <div class="o-header_search_candidate_btns">
          ${each(model.suggest.keyWordArray, SuggestionItem)}
        </div>
      </div>`;
  }
  return html``;
}

const HistorySuggestion = (historySuggest: HistorySuggest) => html`
  ${If(historySuggest.shouldShowSuggestWord, html`
    <div class="o-header_search_candidate_item" data-suggest="cont">
      <div class="a-heading -typep">
        <p class="a-heading_text">${historySuggest.wordTitle}</p>
      </div>
      <div class="o-header_search_candidate_btns">
        ${each(historySuggest.suggestWordArray, SuggestionItem)}
      </div>
    </div>
  `)}
  ${If(historySuggest.shouldShowCategory, html`
    <div class="o-header_search_candidate_item">
      <div class="a-heading -typep">
        <p class="a-heading_text">${historySuggest.categoryTitle}</p>
      </div>
      <div class="o-header_search_candidate_btns">
        ${each(historySuggest.categoryArray, CategorySuggestionItem)}
      </div>
    </div>
  `)}
`;

const SuggestionItem = (suggestWord: string) => {
  return html`
    <div class="o-header_search_candidate_btnwrapper js-header-search-candidatebtn">
      <div class="o-header_search_candidate_btnwrapperinner">
        <button class="o-header_search_candidate_btn js-header-search-candidateselect" type="button" data-suggest="choice"
          @mousedown="${(event: Event) => selectSuggestWord(event)}"
          @keydown="${(event: KeyboardEvent) => {
            selectSuggestWordByEnter(event);
            hideSuggestByTab(event);}
          }"
          >${suggestWord}</button>
      </div>
    </div>`;
}

const CategorySuggestionItem = (categorySuggest: CategorySuggest) => html`
  <div class="o-header_search_candidate_btnwrapper js-header-search-candidatebtn">
    <div class="o-header_search_candidate_btnwrapperinner">
      <button class="o-header_search_candidate_btn js-header-search-candidateselect" type="button" data-suggest="choice"
        data-cate-cd-ll="${categorySuggest.llCategryCode}" data-cate-cd-l="${categorySuggest.lCategoryCode}" data-cate-cd-m="${categorySuggest.mCategoryCode}"
        @mousedown="${(event: Event) => movePageToCategorySearchM(event)}"
        @keydown="${(event: KeyboardEvent) => {
          movePageToCategorySearchM(event);
          hideSuggestByTab(event);}
        }"
        >${categorySuggest.categoryName}</button>
    </div>
  </div>
`;

const movePageToCategorySearchM = (event: Event) => {
  if (event.type === 'keydown' && (event as KeyboardEvent).key !== 'Enter') {
    return;
  }
  const selectedSuggest = event.currentTarget as HTMLInputElement;
  SearchwordSuggestionContainer.setSuggestWord(selectedSuggest.innerText);
  const { dataset } = selectedSuggest;
  window.location.href = "/m/" + dataset.cateCdLl + "-" + dataset.cateCdL + "-" + dataset.cateCdM;
}

const selectSuggestWord = (event: Event) => {
  const selectedSuggestWord = (event.currentTarget as HTMLInputElement).innerText;
  SearchwordSuggestionContainer.setSuggestWord(selectedSuggestWord);
  SearchwordSuggestionContainer.hideSuggest();
}

const selectSuggestWordByEnter = (event: KeyboardEvent) => {
  if (event.key !== 'Enter') {
    return;
  }
  SearchwordSuggestionContainer.setSuggestWord((event.currentTarget as HTMLElement).innerText);
  SearchwordSuggestionContainer.hideSuggest();
}

const hideSuggestByTab = (event: KeyboardEvent) => {
  // Tabキー以外が押下された場合は何もしない
  if (!(event.key === 'Tab' && !event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey)) {
    return;
  }
  const suggestionList = document.querySelectorAll('[data-suggest="choice"]');
  const lastSuggestion = suggestionList[suggestionList.length - 1];
  if (event.currentTarget === lastSuggestion) {
    SearchwordSuggestionContainer.hideSuggest();
  }
}
